import AppData from "../../../Model/AppData"


export const moduleKey = {
    INVENTORY: 'module_inventory'
}

export default class ModuleHelper {
    static moduleEnabled = (moduleKey) => {
        return AppData.data.getMerchantSettingValue(moduleKey) == 1
    }
}